import { render, staticRenderFns } from "./UsuariosFormComponent.vue?vue&type=template&id=364a08d1&"
import script from "./UsuariosFormComponent.vue?vue&type=script&lang=js&"
export * from "./UsuariosFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports